import { Fragment, memo } from 'react';
import ProfessionTitle from './profession-title';

interface OtherDatasProp {
  isEdit?: boolean;
}

const OtherDatasComponent = ({ isEdit }: OtherDatasProp): React.ReactElement => {
  return (
    <Fragment>
      <ProfessionTitle disabled={isEdit} />
    </Fragment>
  );
};

OtherDatasComponent.displayName = 'Other Datas step component';

const OtherDatas = memo(OtherDatasComponent);

export default OtherDatas;
